module.exports = __webpack_public_path__ + "img/MSO.77eecb11.png";